'use client';

import { useEffect, useState } from 'react';
import { CornerTicks } from '@/components/marketing/site/hud';

type Theme = 'dark' | 'light';

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>('dark');

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      const saved = window.localStorage.getItem('mpange-marketing-theme');
      const initial =
        saved === 'light' || saved === 'dark'
          ? saved
          : document.documentElement.dataset.theme === 'light'
            ? 'light'
            : 'dark';
      setTheme(initial);
    });
    return () => window.cancelAnimationFrame(frame);
  }, []);

  function toggle() {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    window.localStorage.setItem('mpange-marketing-theme', next);
    setTheme(next);
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      className="border-line bg-surface hover:border-accent hover:text-accent relative grid h-10 w-10 place-items-center overflow-hidden border transition-colors"
    >
      <CornerTicks className="border-accent/35" size={4} offset={2} />
      <span
        aria-hidden
        className={`absolute text-base transition-all duration-500 ${theme === 'dark' ? 'scale-100 rotate-0 opacity-100' : 'scale-0 rotate-90 opacity-0'}`}
      >
        ☼
      </span>
      <span
        aria-hidden
        className={`absolute text-sm transition-all duration-500 ${theme === 'light' ? 'scale-100 rotate-0 opacity-100' : 'scale-0 -rotate-90 opacity-0'}`}
      >
        ◐
      </span>
    </button>
  );
}
